module.exports = __webpack_public_path__ + "static/process_and_capability_assessment-b3b001c3492fff50e27dfcb3d2a1bf88.jpg";